<!-- Modal Title -->
<div *nzModalTitle class="font-600">
	{{ "global.common.subscription" | translate }} - {{ "pricing.title" | translate }}
</div>

<!-- Modal Content -->
<div *ngIf="!isManaged; else elseIsManaged">
	<div class="center mb-1">
		{{ 'pricing.type' | translate}}:
		<nz-switch style="margin: 10px;" [(ngModel)]="selectedPlanType" (click)="changePlanType()" [nzControl]="true"
			nzCheckedChildren="{{ 'pricing.yearly' | translate}}"
			nzUnCheckedChildren="{{ 'pricing.monthly' | translate}}">
		</nz-switch>
	</div>

	<div class="scrollable">
		<div class="mr-1 ml-1 center" style="display: flex;">
			<nz-card nzHoverable *ngFor="let subscription of defaultSubscriptions" (click)="planSelected(subscription)"
				[ngClass]=" subscription['isSelected'] ? 'subscription-plan-card-selected' : 'subscription-plan-card'"
				style="max-width: 400px;">

				<div class="center mt-0_5">
					<h1> <b> {{ subscription['name'] }} </b> </h1>
				</div>

				<!-- If priceYearly is available -->
				<div *ngIf="(selectedPlanType && getPrice(subscription.priceYearly)); else checkMonthly">
					<div class="center">
						<div>
							<h2 nz-typography *ngIf="selectedPlanType">
								{{ subscription["priceYearly"] | currency: 'EUR':'symbol':defaultCurrencySymbol: currentLanguage }}
								<small> {{ "global.common.year" | translate }} </small>
							</h2>
							<p *ngIf="_profileType === 'supplier'">
								+ 2% {{ "pricing.order_volume" | translate | titlecase }}
								({{ "pricing.basic_price" | translate | titlecase }})
							</p>
						</div>
					</div>
					<div class="mt-0_5">
						<h3 nz-title class="text-center">
							{{ "pricing.benefit_activate_header" | translate }}
						</h3>
						<p *ngFor="let service of subscription['services']" class="text-left">
							<i nz-icon nzType="star" class="color-secondary"></i>
							{{ service }}
						</p>
					</div>
				</div>

				<!-- If priceMontly is available -->
				<ng-template #checkMonthly>
					<div *ngIf="(!selectedPlanType && getPrice(subscription.priceMonthly)); else unavailablePrice">
						<div class="center">
							<div>
								<h2 nz-typography *ngIf="!selectedPlanType">
									{{ subscription["priceMonthly"] | currency: 'EUR':'symbol':defaultCurrencySymbol: currentLanguage }}
									<small> {{ "global.common.month" | translate }} </small>
								</h2>
								<p *ngIf="_profileType === 'supplier'">
									+ 2% {{ "pricing.order_volume" | translate | titlecase }}
									({{ "pricing.basic_price" | translate | titlecase }})
								</p>
							</div>
						</div>
						<div class="mt-0_5">
							<h3 nz-title class="text-center">
								{{ "pricing.benefit_activate_header" | translate }}
							</h3>
							<p *ngFor="let service of subscription['services']" class="text-left">
								<i nz-icon nzType="star" class="color-secondary"></i>
								{{ service }}
							</p>
						</div>
					</div>
				</ng-template>

				<!-- If One of the price is not available -->
				<ng-template #unavailablePrice>
					<div class="unavailable-card-height">
						<h2 class="center"> {{ "pricing.unavailable" | translate }} </h2>
					</div>
				</ng-template>
			</nz-card>
		</div>

		<div class="center mb-1 mt-1">
			<div>
				<label nz-checkbox [(ngModel)]="acceptedTermsConditions"></label> &nbsp;
			</div>
			{{ "global.common.acceptTermsAndConditions" | translate }} &nbsp;
			<a href="https://www.tenderpilot.de/agb/" target="_blank">
				{{ "global.common.agb" | translate }}
			</a>
		</div>
		<div class="center mb-1">
			<button [disabled]="!acceptedTermsConditions || !selectedPlan['isSelected']" (click)="subscribe()" nz-button
				nzType="primary">
				{{ "pricing.subscribe" | translate }}
			</button>
		</div>
	</div>

</div>

<ng-template #elseIsManaged>
	<div class="prices-block__icon" style=" box-shadow: 0 0 0px 1px #13c5d0; background-color: #13c5d0;
		background-image: url(https://www.tenderpilot.com/wp-content/uploads/2020/04/med.png);">
	</div>

	<div class="benefits center">
		<h1>{{ "pricing.congratulations" | translate }}</h1>
	</div>

	<div nz-result-content *ngIf="activeSubscription as active" class="center">
		<div class="desc">
			<h3 nz-title class="text-center">
				{{ "pricing.current_plan_header" | translate }}
			</h3>
			<div>
				<p nz-paragraph>
					<i nz-icon nzType="star" class="color-secondary"></i>
					{{ active.price | currency: 'EUR':'symbol':defaultCurrencySymbol: currentLanguage }}
					{{ active.paymentType === 1 ? ("global.common.month" | translate) : ("global.common.year" | translate) }}
					<span *ngIf="_profileType === 'supplier'">
						+ 2% {{ "pricing.order_volume" | translate | titlecase }}
						({{ "pricing.basic_price" | translate | titlecase }})
					</span>
				</p>
				<p nz-paragraph *ngFor="let service of active.description">
					<i nz-icon nzType="star" class="color-secondary"></i>
					{{ service }}
				</p>
			</div>
		</div>
	</div>
	<div class="text-center font-600">
			{{ "pricing.change_subscription_message" | translate }}
	</div>
</ng-template>
